import React, { useState, useEffect, useContext } from 'react';
import {
    Dialog,
    DialogContent,
    DialogActions,
    Button,
    DialogTitle,
} from '@mui/material';
import { ColorRing } from 'react-loader-spinner';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

import { RenderFields } from './RenderFields';
import VirtualizedAutocomplete from '../../../../components/Dropdown/VirtualizedAutocomplete';
import { AlertContext } from '../../../../components/CustomFunctions/AlertContext';

import { updateContract, deleteContract } from './services/maintenanceContractService';

import {
    contractFields
} from './maintenanceContractFields';

import DeviceContractTable from '../DeviceContractTable/DeviceContractTable';

const ConfirmationDialog = ({ open, title, message, onConfirm, onCancel, confirmButtonText }) => (
    <Dialog
        open={open}
        onClose={onCancel}
        maxWidth="sm"
        fullWidth
        style={{ zIndex: 1600 }}
    >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>{message}</DialogContent>
        <DialogActions>
            <Button onClick={onCancel} color="primary" variant="outlined">
                Cancel
            </Button>
            <Button onClick={onConfirm} color="secondary" variant="outlined">
                {confirmButtonText || 'Confirm'}
            </Button>
        </DialogActions>
    </Dialog>
);


const ViewContractModal = ({
    open,
    handleClose,
    // contract,
    currentIndex,
    setCurrentIndex,
    allContracts,
    updateAll,
    //   allTaxDetails,
    allOptions,



}) => {
    const { alert } = useContext(AlertContext);
    const [isEditable, setIsEditable] = useState(false);
    const [contractData, setContractData] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [buildingLabel, setBuildingLabel] = useState("N/A");
    const [options, setOptions] = useState(allOptions || {});
    const [clearDialogOpen, setClearDialogOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);

    useEffect(() => {

        setOptions(allOptions || {});
    }, [allOptions])



    useEffect(() => {

        if (options?.buildingId) {
            const allBuilding = options?.buildingId || [];
            const building = allBuilding.find((b) => String(b?.buildingID) === String(allContracts[currentIndex]?.buildingId));
            setBuildingLabel(`${building?.buildingID} - ${building?.buildingReference}`);

        }
    }, [options?.buildingId, currentIndex, allContracts]);


    useEffect(() => {
        if (open) {
            setContractData(allContracts[currentIndex]);
        }
    }, [open, allContracts, currentIndex]);





    const updateAllContracts = (contract, isDelete = false) => {
        let all = [...allContracts]
        let index = all.findIndex((c) => String(c.contractId) === String(contract.contractId));
        if (isDelete) {
            all.splice(index, 1);
        } else {
            all[index] = contract;
        }
        updateAll(all);
    }





    const handleNext = () => {
        if (currentIndex + 1 < allContracts.length) {
            setCurrentIndex((prevIndex) => prevIndex + 1);
        }
    };

    const handlePrev = () => {
        if (currentIndex - 1 >= 0) {
            setCurrentIndex((prevIndex) => prevIndex - 1);
        }
    };

    const handleEditClick = () => {
        setIsEditable(true);
    };

    const handleCancelEdit = () => {

        setIsEditable(false);
    };



    const handleSave = async () => {

        alert("Only those device would successfully get added to the contract that are not associated with any other active contract");

        setIsLoading(true);
        const data = { ...contractData };

        try {
            const updatedData = await updateContract(data);
            alert("Contract Updated Successfully");
            setContractData(updatedData);
            updateAllContracts(updatedData);
        }
        catch (error) {
            alert(error.message, true);
        } finally {
            setIsEditable(false);
            setIsLoading(false);
            // handleClose();
        }

        return;
    };


    const handleDeleteContract = async () => {
        setDeleteDialogOpen(true);
    };

    const handleConfirmDelete = async () => {
        try {
            await deleteContract(contractData.contractId);
            alert("Contract Deleted Successfully");
            updateAllContracts(contractData, true);
            handleClose();
        } catch (error) {
            alert(error.message, true);
        } finally {
            setDeleteDialogOpen(false);
        }
    };

    const handleClear = () => {
        setClearDialogOpen(true);
    };

    const handleConfirmClear = () => {
        setContractData((prev) => ({
            ...prev, // Preserve required fields
            contractClass: '',
            contractStatus: '',
            coverageStartDate: '',
            coverageEndDate: '',
            coverageExpiryDate: '',
            lastVisit: '',
            coverageType: '',
            coverage: '',
            visitFrequency: '',
            billingLevel: '',
            bilingFrequency: '',
            invoiceAmount: '',
            increaseDate: '',
            increasePercent: '',
            increaseFrequency: '',
            holdPeriod: '',
            deviceContractsDtos: [],
        }));
        alert("Contract cleared successfully.");
        setClearDialogOpen(false);
    };

    const handleModalClose = (event, reason) => {
        if (isEditable && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            // Prevent closing the modal when in edit mode and the reason is backdropClick or escapeKeyDown
            return;
        }

        setIsEditable(false);
        handleClose();

    };

    const handleFieldChange = (e) => {
        const { name, value } = e.target;
        setContractData((prev) => ({ ...prev, [name]: value }));

    };



    const splitFields = (fieldsArray) => {
        const midIndex = Math.ceil(fieldsArray.length / 2);
        return [fieldsArray.slice(0, midIndex), fieldsArray.slice(midIndex)];
    };

    if (!contractData) {

        return null;
    }

    return (
        <>
            {open && !isEditable && (
                <>
                    {/* Left Arrow Button */}
                    <button
                        onClick={handlePrev}
                        disabled={currentIndex === 0}
                        style={{
                            position: 'fixed',
                            // left: `calc(50% - ${isExpanded ? '45%' : '500px'} - 60px)`,
                            left: 'calc(50% - 45% - 60px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 1500,
                        }}
                        className={`p-2 rounded-full bg-white hover:bg-gray-200 transition ${currentIndex === 0 ? 'opacity-50 cursor-not-allowed' : ''
                            }`}
                        aria-label="Previous Customer"
                    >
                        <ArrowBackIcon />
                    </button>
                    {/* Right Arrow Button */}
                    <button
                        onClick={handleNext}
                        disabled={currentIndex === allContracts.length - 1}
                        style={{
                            position: 'fixed',
                            // right: `calc(50% - ${isExpanded ? '45%' : '500px'} - 60px)`,
                            right: 'calc(50% - 45% - 60px)',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            zIndex: 1500,
                        }}
                        className={`p-2 rounded-full bg-white hover:bg-gray-200 transition ${currentIndex === allContracts.length - 1
                            ? 'opacity-50 cursor-not-allowed'
                            : ''
                            }`}
                        aria-label="Next Customer"
                    >
                        <ArrowForwardIcon />
                    </button>
                </>
            )}


            <Dialog
                open={open}
                onClose={handleModalClose}
                maxWidth={false}
                PaperProps={{
                    style: {
                        // width: isExpanded ? '90%' : '1000px',
                        width: '90%',
                        maxHeight: '90vh',
                        minHeight: '90vh',
                    },
                }}
                fullWidth
                style={{ zIndex: 1400 }}
            >
                {/* Header */}
                <div className="sticky top-0 bg-white z-10">
                    <div className="flex justify-between items-center p-2">
                        {/* Left section: Back button and title */}
                        <div className="flex items-center space-x-2 flex-grow">
                            <button
                                onClick={handleModalClose}
                                className="p-1 rounded-full hover:bg-gray-200 transition"
                                aria-label="Back"
                            >
                                <ArrowBackIcon fontSize='small'/>
                            </button>
                            <h2 className="text-xl font-bold text-left">
                                {isEditable
                                    ? `Edit Contract`
                                    : `View Contract`} - {contractData.contractNumber}
                            </h2>
                        </div>
                        {/* Right section: Expand/Shrink Button */}
                        {/* <button
                            onClick={() => setIsExpanded(!isExpanded)}
                            className="p-2 rounded-full hover:bg-gray-200 transition"
                            aria-label={isExpanded ? 'Shrink Modal' : 'Expand Modal'}
                        >
                            {isExpanded ? <FullscreenExitIcon /> : <FullscreenIcon />}
                        </button> */}
                    </div>
                    <div className="flex justify-end space-x-2 p-2">

                        {isEditable ? (
                            <>
                                <button
                                    onClick={handleCancelEdit}
                                    className="px-6 py-2 text-sm bg-white text-sss-blue-sel font-bold rounded-md border border-sss-blue-sel hover:bg-blue-50 transition"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSave}
                                    className="px-6 py-2 text-sm bg-white text-sss-blue-sel font-bold rounded-md border border-sss-blue-sel hover:bg-blue-50 transition"
                                >
                                    Save
                                </button>
                                <button
                                    onClick={handleClear}
                                    className="px-6 py-2 text-sm bg-white text-sss-blue-sel font-bold rounded-md border border-sss-blue-sel hover:bg-blue-50 transition"
                                >
                                    Clear
                                </button>
                                <button
                                    onClick={handleDeleteContract}
                                    className="px-6 py-2 text-sm bg-white text-red-600 font-bold rounded-md border border-red-600 hover:bg-red-50 transition"
                                >
                                    Delete
                                </button>
                            </>
                        ) : (
                                <button
                                    onClick={handleEditClick}
                                    className="px-6 py-2 text-sm bg-white text-sss-blue-sel font-bold rounded-md border border-sss-blue-sel hover:bg-blue-50 transition"
                                >
                                    Edit
                                </button>
                        )}
                    </div>
                </div>

                <DialogContent dividers>
                    {isLoading ? (
                        <div className="flex flex-col items-center justify-center min-h-[500px]">


                            <ColorRing
                                visible={isLoading}
                                height="200"
                                width="200"
                                ariaLabel="color-ring-loading"
                                colors={['#033B5C', '#033B5C', '#033B5C', '#033B5C', '#033B5C']}
                            />

                            <p>Loading Contract. . .</p>
                        </div>
                    ) : (
                        <div className="p-4 space-y-5 rounded-2xl">
                            
                            <div className="flex justify-between items-center w-full pb-0">
                                {/* Building Site Section (Left Side) */}
                                <div className="flex items-center w-1/2">
                                    <label className="w-1/3 h-10 flex items-center bg-gray-200 px-4 py-2 text-left font-bold text-sss-blue-sel border border-gray-300"
                                        style={{ lineHeight: '1.2', wordBreak: 'break-word' }}>
                                        Building Site
                                    </label>
                                    <VirtualizedAutocomplete
                                        options={options?.buildingId || []}
                                        value={{ buildingId: contractData["buildingId"], buildingLabel: buildingLabel }}
                                        disabled={true}
                                        name="buildingId"
                                        onChange={(e, newValue) => {
                                            if (newValue) {
                                                handleFieldChange({ target: { name: "buildingId", value: newValue.buildingID } });
                                                setBuildingLabel(`${newValue?.buildingID} - ${newValue?.buildingReference}`);
                                            } else {
                                                handleFieldChange({ target: { name: "buildingId", value: null } });
                                                setBuildingLabel(null);
                                            }
                                        }}
                                        optionKey="buildingId"
                                        optionLabel="buildingLabel"
                                        renderOption={(props, option, state) => (
                                            <li {...props} key={option?.buildingID} value={option?.buildingID}>
                                                {option?.buildingID} - {option?.buildingReference}
                                            </li>
                                        )}
                                        filterOptions={(options, state) => {
                                            const inputValue = state.inputValue.toLowerCase();
                                            if (inputValue.trim() === '' || inputValue === null) return options;
                                            return options.filter((option) =>
                                                (String(option?.buildingID) || '').toLowerCase().includes(inputValue) ||
                                                (option.buildingReference || '').toString().toLowerCase().includes(inputValue)
                                            );
                                        }}
                                        className="h-10 border border-gray-300 flex-grow px-4 py-2"
                                    />
                                </div>

                                {/* Status Dropdown (Right Side) */}
                                <div className="flex items-center space-x-2">
                                    <label className="font-medium text-gray-700">Status:</label>
                                    <select
                                        className={`border p-2 rounded-md font-medium transition-colors
                                            ${contractData.contractStatus === "Active" ? "text-green-700" : "text-red-700"}`}
                                        value={contractData.contractStatus}
                                        onChange={(e) => handleFieldChange({ target: { name: "contractStatus", value: e.target.value } })}
                                        disabled={!isEditable}
                                    >
                                        <option value="Active" className="text-green-700">Active</option>
                                        <option value="Pending" className="text-red-700">Pending</option>
                                        <option value="Expired" className="text-red-700">Expired</option>
                                        <option value="Cancelled" className="text-red-700">Cancelled</option>
                                    </select>
                                </div>

                            </div>


                            {(() => {
                                const [generalInfoLeft, generalInfoRight] = splitFields(
                                    contractFields
                                );
                                return (
                                    // <CustomerAccordion label="Coverage Info">
                                        <div
                                            // className={`flex ${isExpanded ? 'flex-row' : 'flex-col md:flex-row'
                                            //     } gap-4`}
                                            className='flex flex-row gap-4'
                                        >
                                            <div className="w-full">
                                                <RenderFields
                                                    fields={generalInfoLeft}
                                                    formData={contractData}
                                                    handleChange={handleFieldChange}
                                                    readOnly={!isEditable}
                                                    allOptions={options}

                                                />
                                            </div>
                                            <div className="w-full">
                                                <RenderFields
                                                    fields={generalInfoRight}
                                                    formData={contractData}
                                                    handleChange={handleFieldChange}
                                                    readOnly={!isEditable}

                                                    allOptions={options}

                                                />
                                            </div>

                                        </div>



                                    // </CustomerAccordion>

                                );
                            })()}

                            
                            {(() => {
                                {/* Devices Table */}
                                return ( 
                                // <CustomerAccordion label="Device Info"> 
                                    <DeviceContractTable
                                        deviceContractsList={contractData.deviceContractsDtos}
                                        availableDevices={contractData.availableDevices}

                                        addDeviceToContract={(deviceId) => {

                                            if (deviceId === '') {
                                                alert("Please select a device", true);
                                                return;
                                            }

                                            const data = { ...contractData };
                                            const device = contractData.availableDevices.find((d) => d.deviceId === deviceId);

                                            const doesAlreadyExist = data.deviceContractsDtos.some((d) => d.deviceId === deviceId);
                                            if (doesAlreadyExist) {
                                                alert("Device already added to contract", true);
                                                return;
                                            }

                                            const deviceContract = {
                                                deviceId: device.deviceId,
                                                contractId: contractData.contractId,
                                                coverageType: contractData.coverageType,
                                                coverage: contractData.coverage,
                                            }

                                            data.deviceContractsDtos.push(deviceContract);
                                            setContractData(data);
                                        }}

                                        removeDeviceFromContract={(deviceId) => {
                                            const data = { ...contractData };
                                            const index = data.deviceContractsDtos.findIndex((d) => d.deviceId === deviceId);
                                            data.deviceContractsDtos.splice(index, 1);
                                            setContractData(data);
                                        }}

                                        coverageOptions={options?.coverage || []}
                                        coverageTypeOptions={options?.coverageType || []}
                                        setDeviceContractsList={
                                            (data) => {
                                                const updatedData = { ...contractData };
                                                updatedData.deviceContractsDtos = data;
                                                setContractData(updatedData);
                                            }
                                        }
                                        isEditMode={isEditable}
                                    />
                                // </CustomerAccordion>
                                );
                            })()}
                        </div>
                    )
                    }



                </DialogContent>
            </Dialog>

            {/* Confirmation Dialogs */}
            <ConfirmationDialog
                open={clearDialogOpen}
                title="Clear Contract"
                message="Are you sure you want to clear this contract?"
                onConfirm={handleConfirmClear}
                onCancel={() => setClearDialogOpen(false)}
                confirmButtonText="Clear it"
            />

            <ConfirmationDialog
                open={deleteDialogOpen}
                title="Delete Contract"
                message="Are you sure you want to delete this contract?"
                onConfirm={handleConfirmDelete}
                onCancel={() => setDeleteDialogOpen(false)}
                confirmButtonText="Delete"
            />

        </>
    );
};

// ViewContractModal.propTypes = {
//   open: PropTypes.bool.isRequired,
//   handleClose: PropTypes.func.isRequired,
//   allContracts: PropTypes.array.isRequired,
//   currentIndex: PropTypes.number.isRequired,
//   handleDataChange: PropTypes.func,
//   isLoading: PropTypes.bool,
// };

export default ViewContractModal;
